import { useRef, useState } from 'react';
import styles from './ManifestoPlayer.module.css';

const BARS = [18, 28, 38, 48, 56, 44, 36, 52, 60, 48, 32, 44, 56, 40, 28, 48, 60, 52, 36, 44, 56, 40, 28, 36, 48, 56, 44, 32];

export function ManifestoPlayer() {
  const audioRef = useRef<HTMLVideoElement>(null);
  const [playing, setPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [loading, setLoading] = useState(true);

  function toggle() {
    const el = audioRef.current;
    if (!el) return;
    if (playing) {
      el.pause();
    } else {
      el.play();
    }
    setPlaying(!playing);
  }

  function onTimeUpdate() {
    const el = audioRef.current;
    if (!el || !el.duration) return;
    setProgress(el.currentTime / el.duration);
  }

  function onEnded() {
    setProgress(0);
    setPlaying(false);
  }

  function seek(e: React.MouseEvent<HTMLDivElement>) {
    const el = audioRef.current;
    if (!el) return;
    const rect = e.currentTarget.getBoundingClientRect();
    const ratio = (e.clientX - rect.left) / rect.width;
    el.currentTime = ratio * el.duration;
    setProgress(ratio);
  }

  return (
    <div className={styles.player}>
      <video
        ref={audioRef}
        src={import.meta.env.VITE_MANIFESTO_URL}
        onTimeUpdate={onTimeUpdate}
        onEnded={onEnded}
        onLoadedMetadata={() => setLoading(false)}
        preload="metadata"
        playsInline
        style={{ display: 'none' }}
      />

      <button
        className={`${styles.playBtn} ${loading ? styles.playBtnLoading : ''}`}
        onClick={loading ? undefined : toggle}
        aria-label={loading ? 'Carregando…' : playing ? 'Pausar manifesto' : 'Ouvir manifesto'}
        aria-busy={loading}
      >
        {loading ? (
          <svg className={styles.spinner} viewBox="0 0 24 24" width="22" height="22" fill="none">
            <circle
              cx="12" cy="12" r="9"
              stroke="var(--color-magenta)"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeDasharray="42.41"
              strokeDashoffset="10.6"
            />
          </svg>
        ) : playing ? (
          <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
            <rect x="5" y="4" width="4" height="16" rx="1" />
            <rect x="15" y="4" width="4" height="16" rx="1" />
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
            <path d="M8 5.14v14l11-7-11-7z" />
          </svg>
        )}
      </button>

      <div
        className={styles.waveWrap}
        onClick={loading ? undefined : seek}
        role="presentation"
        style={{ cursor: loading ? 'default' : 'pointer' }}
      >
        {BARS.map((h, i) => (
          <span
            key={i}
            className={`${styles.bar} ${loading ? styles.barLoading : ''}`}
            style={{
              height: `${h}px`,
              opacity: loading ? undefined : (i / BARS.length < progress ? 1 : 0.45),
              animationDelay: loading ? `${i * 40}ms` : undefined,
            }}
          />
        ))}
      </div>
    </div>
  );
}
